export function ColumnResizeComponent(LayoutService, $timeout) {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      scope.LayoutService.viewMode = LayoutService.viewMode;
      const handleContainer = angular.element('<div class="rc-handle-container" />');
      element.before(handleContainer);
      let drag = false;
      const colClass = i => `.rc-${i.toString()}`;
      const scrollbarWidth = 16;
      // const colPadding = 11;
      if (!LayoutService.customFactColsWidth) LayoutService.customFactColsWidth = {};
      let tableContentWidth = 0;
      const thSelector = 'tr th:visible.facts-col-head';
      let tableColumns;
      const initViewMode = function() {
        let tableWidth = element.width();
        if (!element.width()) {
          tableWidth = parseInt(LayoutService.printWidth, 0);
          element.width(tableWidth);
        }
        // take stock of scrollbar and borders
        tableContentWidth = tableWidth - scrollbarWidth;
        element.find('.fact-table-thead').width(tableWidth - scrollbarWidth);
        initColumnWidths();
      };

      const initViewModeSync = () => {
        $timeout(() => {
          initViewMode();
          $timeout(() => {
            syncHandlers();
          }, 10);
        }, 10);
      };

      scope.$on('viewModeChanged', function(e, vm) {
        $timeout(() => {
          initHandlers();
          $timeout(() => {
            initViewModeSync();
          }, 10);
        }, 10);
      });

      const initHandlers = function() {
        tableColumns = element.find(thSelector);
        handleContainer.empty();
        tableColumns.each(function(index) {
          if (index + 1 === tableColumns.length) {
            return;
          }
          const handle = angular.element('<div class="rc-handle" />');
          handle.data('rc-id', index);
          handle.data('leftCol', this);
          handle.appendTo(handleContainer);
        });
      };

      const syncHandlers = function() {
        const height = element.height();
        let left = 0;
        handleContainer.find('.rc-handle').each(function() {

          const handler = angular.element(this);
          const column = angular.element(handler.data('leftCol'));
          left += column.outerWidth();
          handler.css({
            left: left,
            height: height
          });
        });
      };

      const initColumnWidths = function() {
        if (!scope.LayoutService.viewMode) return;
        scope.LayoutService.viewMode.currentColWidth =
          scope.LayoutService.viewMode.colwidths.map(c => c * tableContentWidth);
      };

      scope.$on('splitter1Changed', function(e, d, d2, name) {
        initViewModeSync();
      });

      scope.$on('splitter1Mouseup', (e, d1, d2, name) => {
        // initViewModeSync();
      });

      scope.$on('splitter3Changed', function(e, d, d2, name) {
        initViewModeSync();
      });

      scope.$on('splitter3Mouseup', (e, d1, d2, name) => {
        initViewModeSync();
      });

      scope.$on('resizeBeforePrint', function(e, d, d2, name) {
        initViewModeSync();
      });

      let startPosition;
      let currentGrip;
      let currentGripPosition;
      let leftColumn;
      let leftColumnId;
      let leftColumnWidth;

      const pointerdown = e => {
        startPosition = e.pageX;
        e.preventDefault();
        drag = true;
        currentGrip = angular.element(e.currentTarget);
        currentGrip.css('background-color', '#0045ff42');
        currentGripPosition = currentGrip.position().left;
        leftColumn = angular.element(currentGrip.data().leftCol);
        leftColumnId = currentGrip.data().rcId;
        leftColumnWidth = leftColumn.width();
      };

      const pointerup = e => {
        if (!drag) {
          return;
        }
        e.preventDefault();
        const endPosition = e.pageX;
        drag = false;
        currentGrip.css('background-color', '');
        const delta = currentGrip.position().left - currentGripPosition;

        scope.LayoutService.viewMode.colwidths[leftColumnId] = (scope.LayoutService.viewMode.currentColWidth[leftColumnId] + delta) *
          scope.LayoutService.viewMode.colwidths[leftColumnId] / scope.LayoutService.viewMode.currentColWidth[leftColumnId];
        scope.LayoutService.viewMode.currentColWidth[leftColumnId] += delta;
        let tailWidth = 0;
        for (let i = leftColumnId + 1; i < scope.LayoutService.viewMode.currentColWidth.length; i++) {
          tailWidth += scope.LayoutService.viewMode.currentColWidth[i];
        }
        const k = (tailWidth - delta) / tailWidth;

        for (let i = leftColumnId + 1; i < scope.LayoutService.viewMode.currentColWidth.length; i++) {
          scope.LayoutService.viewMode.currentColWidth[i] *= k;
          scope.LayoutService.viewMode.colwidths[i] *= k;
        }
        scope.$emit('col-resize');
        scope.$broadcast('col-resize');
        syncHandlers();
      };

      const pointermove = e => {
        if (!drag) {
          return;
        }
        e.preventDefault();
        let delta = e.pageX - startPosition;
        if (leftColumnWidth + delta < 0) {
          delta = -leftColumnWidth;
        }
        if (scope.LayoutService.viewMode) {
          currentGrip.css({
            left: currentGripPosition + delta
          });
        }
      };

      handleContainer.on('mousedown', '.rc-handle', pointerdown);

      document.addEventListener('mouseup', pointerup);
      document.addEventListener('mousemove', pointermove);
      scope.$on('$destroy', () => {
        document.removeEventListener('mouseup', pointerup);
        document.removeEventListener('mousemove', pointermove);
      });
      $timeout(() => {
        if (!handleContainer.find('.rc-handle').length)
          initHandlers();
      }, 0);
    },
  };
}



// WEBPACK FOOTER //
// ./src/facts/colresize.js